import React from 'react';
import { Box, Typography, LinearProgress } from '@mui/material';
import './ChurnForecast.css';

const ChurnForecast = ({ retentionScore }) => {
  const forecastData = [
    { 
      label: 'Good', 
      percentage: retentionScore?.good?.percentage || 0,
      count: retentionScore?.good?.count || 0,
      color: '#572af1' 
    },
    { 
      label: 'Fair', 
      percentage: retentionScore?.fair?.percentage || 0,
      count: retentionScore?.fair?.count || 0,
      color: '#572af1' 
    },
    { 
      label: 'At Risk', 
      percentage: retentionScore?.atRisk?.percentage || 0,
      count: retentionScore?.atRisk?.count || 0,
      color: '#572af1' 
    }
  ];

  return (
    <Box className="cf-container">
      {/* Header */}
      <Typography
        variant="h6"
        gutterBottom
        textAlign="center"
        fontWeight="bold"
        className="cf-title"
      >
        Churn Forecast
      </Typography>

      {/* Forecast Items */}
      <Box className="cf-content">
        {forecastData.map((item, index) => (
          <Box key={index} className="cf-item">
            {/* Label and Percentage */}
            <Box className="cf-label-row">
              <Typography
                sx={{
                  color: '#9CA3AF',
                  fontSize: '20px',
                  fontWeight: 400,
                  fontFamily: 'Albert Sans, sans-serif',
                }}
              >
                {item.label}
              </Typography>
              <Typography
                sx={{
                  color: '#374151',
                  fontSize: '20px',
                  fontWeight: 600,
                  fontFamily: 'Albert Sans, sans-serif',
                }}
              >
                {item.percentage}% ({item.count})
              </Typography>
            </Box>
            
            {/* Progress Bar */}
            <Box className="cf-progress-container">
              <LinearProgress
                variant="determinate"
                value={item.percentage}
                sx={{
                  height: '14px',
                  borderRadius: '6px',
                  backgroundColor: '#E5E7EB',
                  '& .MuiLinearProgress-bar': {
                    backgroundColor: item.color,
                    borderRadius: '6px',
                  },
                }}
              />
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default ChurnForecast;
